import { render, staticRenderFns } from "./ProfileSkeleton.vue?vue&type=template&id=d082b940&scoped=true&"
import script from "./ProfileSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ProfileSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSkeleton.vue?vue&type=style&index=0&id=d082b940&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d082b940",
  null
  
)

export default component.exports